'use client';

import Fade from '@mui/material/Fade';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, MenuItem, Select } from '@/primitives';
import { slate } from '@/lib/colours';
import { useSocietySearchTabsModel } from './useSocietySearchTabsModel';
import { SocietySearchHeaderTabsLoading } from './SocietySearchHeaderTabsLoading';

/**
 * Search-type dropdown for the mobile AppBar (between logo and menu).
 */
export default function SocietySearchTabMobileSelect() {
  const { tabs, tabValue, handleTabChange, societyHeaderTabsLoading } =
    useSocietySearchTabsModel();

  const tabsTransitionKey = tabs.map((t) => t.value).join('|');

  if (societyHeaderTabsLoading) {
    return <SocietySearchHeaderTabsLoading variant="mobile" />;
  }

  return (
    <Fade key={tabsTransitionKey} in timeout={180}>
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex' }}>
        <Select
          inputProps={{
            'data-dd-action-name': 'Tab: Search Type Select',
          }}
          sx={{
            flex: 1,
            minWidth: 0,
            borderRadius: '8px !important',
            height: '36px',
            backgroundColor: 'background.paper',
            fontSize: '12px',
            '.MuiSelect-select': { py: '14.5px' },
            fieldset: { border: `1.5px solid ${slate[300]}` },
          }}
          value={tabValue}
          onChange={(e) => handleTabChange(e.target.value as string)}
        >
          {tabs.map((tab) => (
            <MenuItem
              key={tab.value}
              value={tab.value}
              data-dd-action-name={`Tab: ${tab.label}`}
            >
              {tab.label}
              {tab.icon != null && (
                <LockOutlinedIcon sx={{ fontSize: 16, ml: 0.5 }} />
              )}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Fade>
  );
}
